import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Student } from './student.service';
import { SchoolUser } from './role.service';

@Injectable({ providedIn: 'root' })
export class AssignService {
  private http = inject(HttpClient);

  getConnections(userId: number, q = ''): Observable<any[]> {
    const url = q.trim()
      ? `/api/assign-faculty/${userId}?q=${encodeURIComponent(q)}`
      : `/api/assign-faculty/${userId}`;
    return this.http.get<any[]>(url);
  }

  createConnection(requester_id: number, addressee_id: number): Observable<any> {
    return this.http.post('/api/assign-faculty/create', { requester_id, addressee_id });
  }

  lockConnection(connectionId: number, userId: number): Observable<any> {
    return this.http.put(`/api/assign-faculty/lock`, { connectionId, userId });
  }

  bulkAssignStudents(formData: FormData): Observable<any> {
    return this.http.post('/api/assign-faculty/csv-create', formData);
  }

  removeConnection(connectionId: number, userId: number): Observable<any> {
    return this.http.request('delete', `/api/assign-faculty/${connectionId}`, { body: { userId } });
  }

  getSchoolUsers(): Observable<SchoolUser[]> {
    return this.http.get<SchoolUser[]>(`/api/assign-faculty/school-users`);
  }

  /**
   * Fetches all student records for users school
   * @returns {Observable<Student[]>}
   */
  getAllSchoolStudents(): Observable<Student[]> {
    return this.http.get<Student[]>(`/api/assign-faculty/school`);
  }
}
